module.exports = __webpack_public_path__ + "static/img/mood15.5feb4c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood15.png
// module id = TqaM
// module chunks = 1